<template>
  <div>
    <Modal :title="title" v-model="generateFloatingIpModal" @on-cancel="closeModal" :mask-closable="false">
      <Alert type="error" v-if="error">获取资源池列表失败！</Alert>
      <Form :model="generateFloatingIpForm" ref="generateFloatingIpForm" v-else :rules="generateFloatingIpFormRule">
        <Alert show-icon type="error" v-if="errorMsgShow">{{ errorMsg }}</Alert>
        <FormItem label="资源池(外部网络)" prop="floating_network_id">
          <Select v-model="generateFloatingIpForm.floating_network_id" @on-change="getSubNetList">
            <Option v-for="item in extNetList" :key="item.id" :value="item.id">{{ item.name }}</Option>
          </Select>
        </FormItem>
        <FormItem label="子网" prop="subnet_id">
          <Select clearable placeholder="" v-model="generateFloatingIpForm.subnet_id" not-found-text="请选择拥有子网的资源池">
            <Option v-for="subNetItem in subNetList" :key="subNetItem.id" :value="subNetItem.id">{{ subNetItem.name }} - {{ subNetItem.cidr }}</Option>
          </Select>
        </FormItem>
        <!--<FormItem label="浮动IP地址">-->
          <!--<tooltip placement="right" transfer max-width="200">-->
            <!--<Icon type="ios-help-circle-outline" size="18" />-->
            <!--<div slot="content">-->
              <!--<p>可指定子网内的一个IP地址作为浮动IP地址，如不填将自动分配</p>-->
            <!--</div>-->
          <!--</tooltip>-->
          <!--<Input v-model="generateFloatingIpForm.floating_ip_address" :maxlength="48" />-->
        <!--</FormItem>-->
      </Form>
      <div slot="footer">
        <Button type="primary" @click="submit" :loading="changeLoading">提交</Button>
        <Button @click="generateFloatingIpModal = false" style="margin-left: 8px">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { getPrivateCloudAllNetwork } from '@/api/private-cloud/network'
import { getPrivateCloudAllSubnet } from '@/api/private-cloud/subnet'
import { changePrivateCloudFloatingIp } from '@/api/private-cloud/floating-ip'
export default {
  name: 'generate-floating-ip',
  data () {
    return {
      generateFloatingIpModal: false,
      router_id: '',
      title: '生成浮动IP',
      generateFloatingIpForm: {
        floating_network_id: '',
        subnet_id: '',
        floating_ip_address: ''
      },
      generateFloatingIpFormRule: {
        floating_network_id: [
          { required: true, message: '请选择资源池', trigger: 'change' }
        ],
        subnet_id: [
          { required: true, message: '请选择子网', trigger: 'change' }
        ]
      },
      extNetList: [],
      subNetList: [],
      error: false,
      errorMsg: '',
      errorMsgShow: false,
      changeLoading: false
    }
  },
  methods: {
    // 打开模态框
    openModal () {
      this.getExtNetList()
      this.generateFloatingIpModal = true
    },
    // 关闭模态框
    closeModal () {
      this.resetForm()
    },
    // 获取外网列表
    getExtNetList () {
      getPrivateCloudAllNetwork({ 'router:external': true }).then(res => {
        this.error = false
        this.extNetList = res.data
      }).catch(res => {
        this.error = true
      })
    },
    // 获取子网列表
    getSubNetList (id) {
      for (let i in this.generateFloatingIpForm.external_fixed_ips) {
        this.generateFloatingIpForm.external_fixed_ips[i].subnet_id = ''
      }
      if (id) {
        getPrivateCloudAllSubnet({ network_id: id }).then(res => {
          this.subNetList = res.data
        }).catch(res => {
          this.subNetList = []
        })
      } else {
        this.subNetList = []
      }
    },
    // 提交
    submit () {
      this.$refs['generateFloatingIpForm'].validate((valid) => {
        if (valid) {
          let reqData = {
            floating_network_id: this.generateFloatingIpForm.floating_network_id,
            subnet_id: this.generateFloatingIpForm.subnet_id
          }
          if (this.generateFloatingIpForm.floating_ip_address) {
            reqData.floating_ip_address = this.generateFloatingIpForm.floating_ip_address
          }
          this.changeLoading = true
          changePrivateCloudFloatingIp(reqData).then(res => {
            this.$Notice.success({
              title: '操作成功！'
            })
            this.$emit('generateComplete')
            this.generateFloatingIpModal = false
            this.errorMsgShow = false
            this.changeLoading = false
            this.resetForm()
          }).catch(res => {
            this.changeLoading = false
            if (res.request) {
              this.errorMsg = res.request.responseText
              this.$Notice.error({
                title: '操作失败！',
                desc: res.request.responseText
              })
            } else {
              this.errorMsg = '操作失败！服务器无响应！'
              this.$Notice.error({
                title: '操作失败！服务器无响应！'
              })
            }
            this.errorMsgShow = true
          })
        } else {
          this.$Notice.warning({
            title: '提交失败，请检查表单！'
          })
        }
      })
    },
    // 重置表单
    resetForm () {
      this.generateFloatingIpForm = {
        floating_network_id: '',
        subnet_id: '',
        floating_ip_address: ''
      }
      this.errorMsgShow = false
      this.error = false
    }
  }
}
</script>

<style scoped>

</style>
